import bilAPI from "./api";

// `mine: true` narrows the directory to the caller's organization subtree
// (own school + child schools) — what the school selector should offer.
// `page_size` must be forwarded: the selector asks for the WHOLE subtree in one
// request, and dropping it silently applied DRF's PAGE_SIZE=20, so a network of
// 61 schools offered its head office only the first 20 of them.
export const getOrganizations = ({
  params: { page, page_size, mine } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/org/organizations/`, { params: { page, page_size, mine }, signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Staff ↔ organization employment links (paginated envelope). Rows are flat:
// user / organization / department are uuid strings, subjects is a uuid list,
// plus start_date / end_date / is_in_progress. Filter by `user` +
// `is_in_progress` to get a teacher's current employment row(s).
export const getStaffOrganizations = ({
  params: { user, is_in_progress } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/org/staff-organizations/`, {
          params: { user, is_in_progress },
          signal,
        })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Departments for a school (unpaginated) — `organization` is the school uuid.
// Resolves to a flat array of { uuid, organization, name, code, head, ... }.
export const getDepartments = ({ params: { organization } = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/org/departments/`, { params: { organization }, signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Department CRUD (manager-scoped on the backend to the user's own school).
export const createDepartment = ({ body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/org/departments/`, body, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const updateDepartment = ({ uuid, body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/org/departments/${uuid}/`, body, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteDepartment = ({ uuid, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/org/departments/${uuid}/`, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

// Subject catalog (unpaginated) — backs the Profile subject picker. Resolves to
// a flat array of { uuid, name, code, is_active, ... }.
export const getDomainSubjects = ({ params = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/org/domain-subjects/`, { params, signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
